import { isObject } from 'lodash'

// The backend responds to a non-2xx request with `{ errors: ... }` (see
// ApplicationController#respond_with_error): usually a flat array of human-readable
// strings, but a few contract-validation endpoints legitimately send a nested per-field
// Hash instead (e.g. { result_params: { entity: ['must be filled'] } }) - reduceObjectToMessage
// turns that into a readable list rather than requiring every caller to special-case it.
// `data?.message` is only a safety net for responses this parser hasn't seen (e.g. a
// network-level error with no response body, or an empty errors array), not a shape this
// API produces on purpose.
export const parseErrorResponse = error => {
  if (!error) return null
  const { data } = error
  const { errors } = data ?? {}

  if (Array.isArray(errors) && errors.length) return errors[0]
  if (errors && !Array.isArray(errors)) return errors

  return data?.message ?? data
}

export const parseErrorResponseMessage = error => {
  if (!error) return null
  const { data } = error
  const { errors } = data ?? {}

  if (Array.isArray(errors)) {
    if (!errors.length) return data?.message ?? null

    return errors.reduce(
      (message, err) => message + `${isObject(err) ? reduceObjectToMessage(err) : err} \n`,
      'Error : '
    )
  }

  if (errors) return reduceObjectToMessage(errors)

  return data?.message ?? null
}

const stringifyErrorValue = value => {
  if (Array.isArray(value)) return value.map(stringifyErrorValue).join(', ')
  if (isObject(value)) return reduceObjectToMessage(value)
  return value
}

const reduceObjectToMessage = obj =>
  Object.keys(obj).reduce((message, key) => message + `${key} ${stringifyErrorValue(obj[key])}\n`, '')
